import { Activity, MessageSquare, Users, TrendingUp, MapPin, CheckCheck } from "lucide-react";

export function DashboardMock() {
  return (
    <div className="relative rounded-2xl bg-white shadow-elegant border border-border overflow-hidden">
      {/* Top bar */}
      <div className="flex items-center gap-2 px-4 py-3 border-b border-border bg-muted/40">
        <div className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-destructive/70" />
          <span className="h-2.5 w-2.5 rounded-full bg-highlight" />
          <span className="h-2.5 w-2.5 rounded-full bg-success" />
        </div>
        <div className="mx-auto text-xs text-muted-foreground font-medium">
          voxcampaign.online / painel
        </div>
      </div>

      <div className="grid grid-cols-12 min-h-[420px]">
        {/* Sidebar */}
        <aside className="col-span-3 bg-primary text-primary-foreground p-4 hidden md:block">
          <div className="text-[11px] uppercase tracking-widest text-primary-foreground/60 mb-3">Painel</div>
          <ul className="space-y-1.5 text-sm">
            {[
              { icon: Activity, label: "Visão geral", active: true },
              { icon: Users, label: "Eleitores" },
              { icon: MessageSquare, label: "Campanhas" },
              { icon: MapPin, label: "Territórios" },
              { icon: TrendingUp, label: "Analytics" },
            ].map(({ icon: Icon, label, active }) => (
              <li
                key={label}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg ${
                  active ? "bg-accent/30 text-primary-foreground" : "text-primary-foreground/70"
                }`}
              >
                <Icon className="h-4 w-4" />
                {label}
              </li>
            ))}
          </ul>
        </aside>

        {/* Main */}
        <main className="col-span-12 md:col-span-9 p-5 space-y-4">
          {/* KPIs */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { label: "Mensagens enviadas", value: "184.5k", trend: "+12,4%", color: "text-success" },
              { label: "Taxa de leitura", value: "87%", trend: "+3,1%", color: "text-success" },
              { label: "Respostas", value: "21.302", trend: "+18%", color: "text-success" },
              { label: "Apoiadores", value: "9.418", trend: "+204", color: "text-accent" },
            ].map((k) => (
              <div key={k.label} className="rounded-xl border border-border bg-card p-3">
                <div className="text-[11px] text-muted-foreground">{k.label}</div>
                <div className="text-xl font-bold text-foreground mt-1">{k.value}</div>
                <div className={`text-[11px] font-semibold mt-0.5 ${k.color}`}>{k.trend}</div>
              </div>
            ))}
          </div>

          {/* Chart */}
          <div className="rounded-xl border border-border bg-card p-4">
            <div className="flex items-center justify-between mb-3">
              <div>
                <div className="text-sm font-semibold text-foreground">Engajamento por região</div>
                <div className="text-[11px] text-muted-foreground">Últimos 30 dias</div>
              </div>
              <div className="flex gap-3 text-[11px] text-muted-foreground">
                <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-primary" /> Enviadas</span>
                <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-success" /> Lidas</span>
                <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-highlight" /> Respostas</span>
              </div>
            </div>
            <div className="flex items-end gap-2 h-32">
              {[55, 70, 48, 82, 64, 90, 76, 95, 68, 88, 74, 96].map((h, i) => (
                <div key={i} className="flex-1 flex flex-col items-center gap-0.5">
                  <div className="w-full rounded-t bg-primary" style={{ height: `${h * 0.45}%` }} />
                  <div className="w-full bg-success" style={{ height: `${h * 0.35}%` }} />
                  <div className="w-full rounded-b bg-highlight" style={{ height: `${h * 0.18}%` }} />
                </div>
              ))}
            </div>
          </div>

          {/* Recent */}
          <div className="rounded-xl border border-border bg-card p-4">
            <div className="text-sm font-semibold text-foreground mb-2">Disparos recentes</div>
            <ul className="space-y-2 text-xs">
              {[
                { name: "Mobilização — Zona Norte", status: "Entregue", count: "12.480", icon: CheckCheck, color: "text-success" },
                { name: "Confirmação de evento", status: "Em envio", count: "5.220", icon: MessageSquare, color: "text-accent" },
                { name: "Pesquisa de pautas", status: "Agendado", count: "8.900", icon: Activity, color: "text-highlight-foreground" },
              ].map((r) => (
                <li key={r.name} className="flex items-center justify-between border-b border-border last:border-0 pb-2 last:pb-0">
                  <div className="flex items-center gap-2">
                    <r.icon className={`h-3.5 w-3.5 ${r.color}`} />
                    <span className="font-medium text-foreground">{r.name}</span>
                  </div>
                  <div className="flex items-center gap-4 text-muted-foreground">
                    <span>{r.count} contatos</span>
                    <span className={`font-semibold ${r.color}`}>{r.status}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </main>
      </div>
    </div>
  );
}
